module.exports = __webpack_public_path__ + "static/img/004.12389d60.png";